import React from 'react'

const Kazan2 = () => {
    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Kazan 2</h2>
            <p>Bu sayfa hen�z haz1rlanmam1_t1r.</p>
        </div>
    )
}

export default Kazan2
